/*
 * @Author: yangecheng
 * @Date: 2021-09-30 13:05:56
 * @Description: 
 */
import ReactDOM from 'react-dom';
import TabsPage from './TabsPage';

ReactDOM.render(
  <TabsPage />,
  document.getElementById('root')
);

